import { render } from "./TripsAddUpdateCopy.vue?vue&type=template&id=45313874&scoped=true"
import script from "./TripsAddUpdateCopy.vue?vue&type=script&lang=js"
export * from "./TripsAddUpdateCopy.vue?vue&type=script&lang=js"

import "./TripsAddUpdateCopy.vue?vue&type=style&index=0&id=45313874&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45313874"]])

export default __exports__